import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faInfoCircle } from '@fortawesome/pro-light-svg-icons'

import {
  Form, HoverHintWrapper, Text,
} from '@domain-group/suit-theme'

import { formatEntityCount } from '@functions/entity'

import type { ArtworkPageModel } from '@models/types'

interface OverlaysProps {
  overlays: ArtworkPageModel['overlays'],
}

const Overlays = (props: OverlaysProps) => {
  const { overlays } = props

  return (
    <Form.Field label="Overlays" marginTop="large">
      <HoverHintWrapper
        hintComponent={(
          <HoverHintWrapper.Hint boxProps={{ flexDirection: 'column', padding: 'medium', paddingTop: 'small' }}>
            {/*
             // @ts-expect-error TS18048 */}
            {overlays.map(overlay => (
              <Text color="white" marginTop="small">
                <FontAwesomeIcon icon={faFile} />&nbsp;{overlay.items.join(' ')}
              </Text>
            ))}
          </HoverHintWrapper.Hint>
        )}
        // @ts-expect-error TS2322
        width="fit-content"
      >
        <Text>
          <FontAwesomeIcon icon={faInfoCircle} />
          {/*
           // @ts-expect-error TS18048 */}
          &nbsp;{formatEntityCount({ entityCount: overlays.length, entityString: 'x Overlay' })}
        </Text>
      </HoverHintWrapper>
    </Form.Field>
  )
}

export default Overlays
